import { Link, useLocation } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import { useAuth } from "./context/AuthContext";

function App() {
  const { token, logout } = useAuth();
  const location = useLocation();
  const isLanding = location.pathname === "/";
  const isAuthPage = location.pathname === "/login" || location.pathname === "/register";
  const isDashboardRoute = ["/dashboard", "/upload", "/timeline", "/insights", "/alerts", "/settings"].includes(
    location.pathname
  );

  // Landing and auth pages: no wrapper
  if (isLanding || isAuthPage) {
    return <AppRouter />;
  }

  // Dashboard routes: the DashboardLayout is embedded in Dashboard.jsx
  if (isDashboardRoute) {
    return <AppRouter />;
  }

  // Fallback for other pages
  return (
    <div className="container">
      <header className="header">
        <h1>HealthTimeline AI</h1>
        {token ? (
          <nav className="nav">
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/upload">Upload</Link>
            <Link to="/timeline">Timeline</Link>
            <Link to="/insights">Insights</Link>
            <button onClick={logout}>Logout</button>
          </nav>
        ) : (
          <nav className="nav">
            <Link to="/login">Login</Link>
            <Link to="/register">Sign Up</Link>
          </nav>
        )}
      </header>

      <AppRouter />
    </div>
  );
}

export default App;
